import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// model制御用のvuex module
import loginAuth from '@/vuex/modules/loginAuth/index'
import account from '@/vuex/modules/account/index'
import accountList from '@/vuex/modules/accountList/index'
import accountAuth from '@/vuex/modules/accountAuth/index'
import pagePermission from '@/vuex/modules/ui/pagePermission/index'
import agency from '@/vuex/modules/agency/index'
import campaign from '@/vuex/modules/campaign'
import campaignDashboard from '@/vuex/modules/campaignDashboard/index'
import currentAdvertiser from '@/vuex/modules/currentAdvertiser/index'
import currentAgency from '@/vuex/modules/currentAgency/index'
import advertiserAccountAuth from '@/vuex/modules/advertiserAccountAuth/index'
import agencyAccountAuth from '@/vuex/modules/agencyAccountAuth/index'
import inventoryListTargeting from '@/vuex/modules/inventoryListTargeting'
import IPRangeListTargeting from '@/vuex/modules/IPRangeListTargeting/index'
import progressReport from '@/vuex/modules/progressReport/index'
import pointGroupOperation from '@/vuex/modules/pointGroupOperation/index'
import pointGroupCatalog from '@/vuex/modules/pointGroupCatalog/index'
import menu from '@/vuex/modules/menu/index'
import master from '@/vuex/modules/master/index'
import agencyMargin from '@/vuex/modules/agencyMargin/index'
import dashboard from '@/vuex/modules/dashboard'
import mapReport from './modules/mapReport/index'
import mapReportForAdmin from './modules/admin/request/mapReport/index'
import simulation from '@/vuex/modules/simulation/index'
import advertiser from '@/vuex/modules/advertiser/index'

// pathに基づく vuex module
import admin from '@/vuex/modules/admin/index'

// UI制御用のvuex module
import drawer from '@/vuex/modules/ui/drawer/index'
import drawerToggleButton from '@/vuex/modules/ui/drawerToggleButton/index'
import drawerUriAuths from '@/vuex/modules/ui/drawerUriAuths/index'
import toolbar from '@/vuex/modules/ui/toolbar/index'
import loader from '@/vuex/modules/loader'
import snackbar from '@/vuex/modules/ui/snackbar'
import colorTheme from '@/vuex/modules/ui/colorTheme'

Vue.use(Vuex)

export const storeConfig = {
  modules: {
    loginAuth,
    account,
    accountList,
    accountAuth,
    pagePermission,
    drawer,
    drawerToggleButton,
    agency,
    campaign,
    campaignDashboard,
    currentAdvertiser,
    currentAgency,
    advertiserAccountAuth,
    agencyAccountAuth,
    drawerUriAuths,
    toolbar,
    loader,
    snackbar,
    colorTheme,
    inventoryListTargeting,
    IPRangeListTargeting,
    progressReport,
    pointGroupOperation,
    pointGroupCatalog,
    menu,
    master,
    agencyMargin,
    dashboard,
    admin,
    advertiser,
    mapReport,
    mapReportForAdmin,
    simulation,
  },
  plugins: [
    createPersistedState({
      key: 'GeologicAdmin',
      paths: [
        'dashboard.sortOptions',
        'dashboard.filter',
        'admin.request.budget.sortOptions',
        'admin.request.budget.filter',
        'admin.request.agencyMargin.sortOptions',
        'admin.request.agencyMargin.filter',
        'pointGroupOperation.editMode.pagePermission',
      ],
    }),
  ],
}
const store = new Vuex.Store(storeConfig)

export default store
